import React from "react";
import { RouteProps, Link } from "react-router-dom";
import { IPlan } from "../../../services/api/Plan";
import Button from "../../../components/Form/Button";
import ItemBox from "../../../components/ItemBox";

interface GroupListProps extends RouteProps {
  data: IPlan[];
  year: Number;
  month: Number;
}

const GroupList: React.FC<GroupListProps> = ({ data, year, month }) => {
  function renderRow(plan: IPlan) {
    return (
      <li key={plan.groupId}>
        <ItemBox
          {...(plan.children ? { className: "hasChildren" } : null)}
          name={plan.groupName + " - " + plan.groupCode}
        >
          {plan.groupParentId ? (
            <Link
              to={"/plan-update/" + plan.groupId + "/" + year + "/" + month}
            >
              <Button className="box__edit" title="Details" />
            </Link>
          ) : null}
        </ItemBox>

        {plan.children ? (
          <ul className="groups__list"> {plan.children.map(renderRow)}</ul>
        ) : null}
      </li>
    );
  }

  return (
    <React.Fragment>
      <ul className="groups__list groups__list--main">{data.map(renderRow)}</ul>
    </React.Fragment>
  );
};

export default GroupList;
